import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useTranslation } from 'react-i18next';

import { StoreKeys } from '../../hooks/useStore/state';
import { useStore } from '../../hooks/useStore/useStore';
import { phoneOnly } from '../ConstantsStyles';
import { ProviderIndicator } from './DetailsPageHeader.styled';

type Props = {
  inNetwork: string;
  iconColor?: string;
  inNetworkTextColor?: string;
  networkInfo?: string;
};

export const InNetworkStatusLabel = ({
  inNetwork,
  iconColor = '$core.color.green.100',
  inNetworkTextColor = '$core.color.brand.100',
  networkInfo = '',
}: Props) => {
  const { t } = useTranslation();
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const mobileScreen = useMediaQuery(phoneOnly) || isWidget;

  /**
   * Note:
   * There are only two possible values for inNetwork according to getNetworkStatus() utils Fn (Source of this data)
   *  INN = 'In-network',
   *  OON = 'Out-of-network',
   *
   * */
  if (inNetwork === 'In-network') {
    return (
      <Layout.Group
        css={{
          marginRight: '24px',
          '@media (max-width: 464px)': {
            marginRight: '16px',
          },
        }}
        space={0}
      >
        <IconSymbol
          color={iconColor}
          icon="check_circle"
          size={mobileScreen ? '20px' : '$md'}
        />
        <ProviderIndicator
          aria-label={`${t(inNetwork)}.`}
          color={inNetworkTextColor}
          css={{ fontWeight: '$providerDetailsDrawerHeaderInNetworkFW' }}
          data-auto-testid={'detail-network-status-label'}
          data-testid={'detail-network-status-label'}
          fontSize={mobileScreen ? 'md' : 'lg'}
        >
          {t(inNetwork)}
          {networkInfo && `: ${networkInfo}`}
        </ProviderIndicator>
      </Layout.Group>
    );
  }
  return null;
  // TODO: Else case when provider with selected location is OON = 'Out-of-network' OR Not Available. We need to know Figma or UX case details if any/
};
